// src/pages/finance/FinancePage.js
import React, { useState, useEffect } from 'react'
import { collection, onSnapshot, query, where, orderBy } from 'firebase/firestore'
import { db } from '../../firebaseConfig'
import SaldoMitraPage from './SaldoMitraPage'
import PengeluaranPage from './PengeluaranPage'
import SaldoUserPage from './SaldoUserPage'
import ReferralManagementPage from './ReferralManagementPage' // [BARU]
import MisiManagementPage from './MisiManagementPage'         // [BARU]
import SaldoAplikasiPage from './SaldoAplikasiPage'           // [BARU]

export default function FinancePage() {
  const [activeTab, setActiveTab] = useState('saldo_user')
  
  // 👈 STATE PUSAT UNTUK LIFTING STATE UP
  const [orders, setOrders] = useState([])
  const [expenses, setExpenses] = useState([])

  useEffect(() => {
    // 1. Fetch Orders (Sekali Saja)
    const qOrders = query(collection(db, 'orders'), where('status', '==', 'completed'), orderBy('createdAt', 'desc'))
    const unsubOrders = onSnapshot(qOrders, (snap) => {
      setOrders(snap.docs.map(doc => ({ id: doc.id, ...doc.data(), date: doc.data().createdAt?.toDate() || new Date() })))
    })

    // 2. Fetch Expenses (Sekali Saja)
    const qExp = query(collection(db, 'company_expenses'), orderBy('createdAt', 'desc'))
    const unsubExp = onSnapshot(qExp, (snap) => {
      setExpenses(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    })

    return () => {
      unsubOrders()
      unsubExp()
    }
  }, [])

  // Helper untuk class tab
  const getTabClass = (tabName) => {
    const isActive = activeTab === tabName
    return `pb-4 px-4 font-medium transition-colors relative whitespace-nowrap ${
      isActive ? 'text-blue-400' : 'text-gray-400 hover:text-blue-300'
    }`
  }

  // Helper untuk indikator garis bawah
  const renderIndicator = (tabName) => {
    if (activeTab === tabName) {
      return <div className="absolute bottom-0 left-0 w-full h-1 bg-blue-600 rounded-t-full"></div>
    }
    return null
  }

  return (
    <div className="p-6 bg-gray-900 min-h-screen text-gray-100">
      <h1 className="text-2xl font-bold mb-6 text-white">
        💰 Finance & Rewards Management
      </h1>

      {/* Container Tab: Scrollable secara horizontal jika menu banyak */}
      <div className="flex border-b border-gray-700 mb-6 bg-gray-800 pt-4 rounded-t-lg shadow-sm overflow-x-auto">
        
        <button onClick={() => setActiveTab('saldo_user')} className={getTabClass('saldo_user')}>
          Saldo User
          {renderIndicator('saldo_user')}
        </button>

        <button onClick={() => setActiveTab('saldo_mitra')} className={getTabClass('saldo_mitra')}>
          Saldo Mitra
          {renderIndicator('saldo_mitra')}
        </button>

        <button onClick={() => setActiveTab('referral')} className={getTabClass('referral')}>
          Program Referral
          {renderIndicator('referral')}
        </button>

        <button onClick={() => setActiveTab('misi')} className={getTabClass('misi')}>
          Misi Mitra
          {renderIndicator('misi')}
        </button>

        <button onClick={() => setActiveTab('saldo_aplikasi')} className={getTabClass('saldo_aplikasi')}>
          Saldo Aplikasi
          {renderIndicator('saldo_aplikasi')}
        </button>

        <button onClick={() => setActiveTab('komisi')} className={getTabClass('komisi')}>
          Beban Operasional
          {renderIndicator('komisi')}
        </button>

      </div>

      {/* TAB CONTENT */}
      <div className="animate-fade-in min-h-[400px]">
        {activeTab === 'saldo_user' && <SaldoUserPage />}
        {activeTab === 'saldo_mitra' && <SaldoMitraPage />}
        {activeTab === 'referral' && <ReferralManagementPage />}
        {activeTab === 'misi' && <MisiManagementPage />}
        
        {/* 👈 KIRIM DATA PROPS KE CHILD COMPONENT */}
        {activeTab === 'saldo_aplikasi' && <SaldoAplikasiPage orders={orders} />}
        {activeTab === 'komisi' && <PengeluaranPage orders={orders} expenses={expenses} />}
      </div>
    </div>
  )
}